import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";

import { ErrorLogModalLabel } from "./ErrorLogModalLabel";

const mapStateToProps = (state: FullFormState) => ({
    minitourEnabled: state.settings.useExtendedErrorLog,
});

export const ErrorLogModalLabelContainer = connect(mapStateToProps)(ErrorLogModalLabel);
